export default __webpack_public_path__ + "static/media/330_store04-fr-mobile.ee30721d.png";